import PropTypes from 'prop-types';
// material-ui
import { keyframes, useTheme } from '@mui/material/styles';

import { Avatar, Box, Button, ButtonBase, Tooltip, Menu, MenuItem } from '@mui/material';
// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import ThemeButton from 'ui-component/ThemeButton';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
// assets
import { IconMenu2 } from '@tabler/icons-react';
import CloudIcon from '@mui/icons-material/Cloud';
import React from 'react';
// 自定义向右斜着向上弯的箭头
// ==============================|| MAIN NAVBAR / HEADER ||============================== //


const bounce = keyframes`
      0%, 20%, 50%, 80%, 100% {
          transform: translateY(-12px);
      }
      40% {
          transform: translateY(-25px);
      }
      60% {
          transform: translateY(-14px);
      }
  `;
const Header = ({ handleLeftDrawerToggle }) => {
  const account = useSelector((state) => state.account);
  const { pathname } = useLocation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>

        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              ...theme.typography.menuButton,
              transition: 'all .2s ease-in-out',
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{
        display: { xs: 'none', md: 'inline' }, // 移动端隐藏
        alignItems: 'center',
        minHeight: 50
      }}>
        <Tooltip title="集成下载器" arrow>
          <Button
            component={Link}
            size="large"
            variant="text"
            to="/home"
            color={pathname === '/home' ? 'primary' : 'inherit'}
            sx={{
              fontSize: '1.2rem' // 调整字体大小，例如 1.5rem
            }}
          >
                <span>
                  方案1
                </span>
          </Button>
        </Tooltip>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              marginLeft: '-25px', // 左移整体位置
              animation: `${bounce} 2s infinite` // 动画应用到容器
            }}
          >
            <CloudIcon
              sx={{
                color: 'skyblue',
                fontSize: 20,
                marginRight: '1px' // 与文字的间距
              }}
            />
            <span
              style={{
                fontSize: '0.8rem', // 调整字体大小
                color: pathname === '/boost' ? 'primary' : 'inherit'
              }}
            >
                  下载器
                  </span>
          </Box>
      </Box>
      <Box sx={{
        display: { xs: 'none', md: 'inline' }, // 移动端隐藏
        position: 'relative',
        alignItems: 'center',
        minHeight: 50
      }}>
        <Tooltip title="加速器+批量解析工具" arrow>
          <Button
            component={Link}
            size="large"
            variant="text"
            to="/boost"
            color={pathname === '/boost' ? 'primary' : 'inherit'}
            sx={{
              fontSize: '1.2rem' // 调整字体大小
            }}
          >
            方案2
          </Button>
        </Tooltip>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              marginLeft: '-25px', // 左移整体位置
              animation: `${bounce} 2s infinite` // 动画应用到容器
            }}
          >
            <CloudIcon
              sx={{
                color: 'skyblue',
                fontSize: 20,
                marginRight: '1px' // 与文字的间距
              }}
            />
            <span
              style={{
                fontSize: '0.8rem', // 调整字体大小
                color: pathname === '/boost' ? 'primary' : 'inherit'
              }}
            >
                    加速器
                  </span>
          </Box>

      </Box>
      {account.user &&  (
        <>
          <Button
            component={Link}
            size="small"
            variant="text"
            to="/boost"
            color={pathname === '/boost' ? 'primary' : 'inherit'}
            sx={{
              display: { xs: 'inline', md: 'none' }, // PC// 端隐藏
              fontSize: '1.0rem' // 调整字体大小
            }}
          >
            APP
          </Button>
          <Button
            component={Link}
            size="small"
            variant="text"
            to="/panel/quota"
            color={pathname === '/panel/quota' ? 'primary' : 'inherit'}
            sx={{
              display: { xs: 'inline', md: 'none' }, // PC// 端隐藏
              fontSize: '1.0rem' // 调整字体大小
            }}
          >
             套餐
           </Button>
           <Button
             component={Link}
             size="small"
             variant="text"
             to="/panel/sms"
             color={pathname === '/panel/sms' ? 'primary' : 'inherit'}
             sx={{
               fontSize: '1.0rem'
             }}
           >
             短信
           </Button>
           <Button
            size="small"
            variant="text"
            sx={{
              fontSize: '1.0rem'
            }}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            更多 ▾
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem component={Link} to="/panel/nomark" onClick={() => setAnchorEl(null)}>
              水印
            </MenuItem>
            <MenuItem component={Link} to="/panel" onClick={() => setAnchorEl(null)}>
              总览
            </MenuItem>
          </Menu>
        </>

        )}
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
